import { Box } from '@bonusly/design-system';

const BARS = [
	{ color: '#fc41ff', width: '85%', left: '-10%', duration: '22s', delay: '0s' },
	{ color: '#d3ff32', width: '70%', left: '20%', duration: '26s', delay: '-8s' },
	{ color: '#0cffe7', width: '95%', left: '-5%', duration: '18s', delay: '-14s' },
	{ color: '#7733ff', width: '65%', left: '30%', duration: '24s', delay: '-4s' },
];

export function BizyAmbientGlow() {
	return (
		<Box
			position="absolute"
			top="-8px"
			left="-10px"
			right="-10px"
			bottom="-8px"
			overflow="hidden"
			borderRadius="18px"
			filter="blur(56px)"
			pointerEvents="none"
			zIndex={0}
		>
			{BARS.map((bar, i) => (
				<Box
					key={i}
					position="absolute"
					top={0}
					left={bar.left}
					width={bar.width}
					height="100%"
					bg={bar.color}
					opacity={0.3}
					sx={{
						[`@keyframes drift${i}`]: {
							'0%': { transform: 'translateX(-30%)' },
							'50%': { transform: 'translateX(30%)' },
							'100%': { transform: 'translateX(-30%)' },
						},
						animation: `drift${i} ${bar.duration} ease-in-out ${bar.delay} infinite`,
						willChange: 'transform',
					}}
				/>
			))}
		</Box>
	);
}
